import { Reveal } from "./shared";

// Inputs -> Interactions -> Dynamics -> Decisions
export const FlowDiagram = () => {
  const steps = [
    { n: "01", label: "Inputs", sub: "Mechanisms, data, constraints" },
    { n: "02", label: "Interactions", sub: "Feedback loops, thresholds" },
    { n: "03", label: "Dynamics", sub: "Nonlinear change over time" },
    { n: "04", label: "Decisions", sub: "Insight, hypotheses, next steps" },
  ];
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-px bg-white/10 border border-white/10">
      {steps.map((s, i) => (
        <Reveal key={s.n} delay={i * 120}>
          <div className="bg-charcoal p-8 h-full relative group hover:bg-charcoal-muted transition-colors">
            <span className="font-mono-sci text-xs text-acid">{s.n}</span>
            <div className="mt-6 flex items-center gap-2">
              <span className="w-2 h-2 bg-acid rounded-full pulse-node" style={{ animationDelay: `${i * 400}ms` }} />
              <h3 className="text-xl text-white">{s.label}</h3>
            </div>
            <p className="mt-3 text-sm text-white/50 leading-relaxed">{s.sub}</p>
            {i < 3 && (
              <span className="hidden md:block absolute top-1/2 -right-3 z-10 text-acid text-lg">→</span>
            )}
          </div>
        </Reveal>
      ))}
    </div>
  );
};

// Cellular state transition: 5 states
const STATES = [
  { key: "healthy", label: "Healthy proliferation" },
  { key: "adaptation", label: "Adaptation & recovery" },
  { key: "dysfunction", label: "Cellular dysfunction" },
  { key: "senescence", label: "Senescence" },
  { key: "apoptosis", label: "Apoptosis" },
];

export const StateTransition = ({ dark = false }) => {
  const line = dark ? "rgba(255,255,255,0.25)" : "rgba(0,0,0,0.18)";
  const text = dark ? "#ffffff" : "#0a0a0a";
  const subtext = dark ? "rgba(255,255,255,0.5)" : "rgba(0,0,0,0.45)";
  return (
    <div className="w-full overflow-x-auto diagram-scroll">
      <svg viewBox="0 0 960 220" className="w-full min-w-[720px]" role="img" aria-label="Cellular state transition diagram">
        <defs>
          <marker id="arrow" markerWidth="8" markerHeight="8" refX="6" refY="3" orient="auto">
            <path d="M0,0 L6,3 L0,6" fill="none" stroke={line} strokeWidth="1" />
          </marker>
        </defs>
        {STATES.map((s, i) => {
          const x = 40 + i * 220;
          const cx = x + 70;
          const cy = 110;
          const active = i === 3;
          return (
            <g key={s.key}>
              {i < STATES.length - 1 && (
                <line
                  x1={cx + 62}
                  y1={cy}
                  x2={cx + 148}
                  y2={cy}
                  stroke={line}
                  strokeWidth="1"
                  markerEnd="url(#arrow)"
                  className="dash-flow"
                />
              )}
              <circle cx={cx} cy={cy} r="56" fill="none" stroke={line} strokeWidth="1" />
              <circle cx={cx} cy={cy} r="4" fill={active ? "#C2F751" : line} className={active ? "pulse-node" : ""} />
              <text x={cx} y={cy - 74} textAnchor="middle" fill={subtext} className="font-mono-sci" style={{ fontSize: 10, letterSpacing: 1 }}>
                {String(i + 1).padStart(2, "0")}
              </text>
              <text x={cx} y={cy + 82} textAnchor="middle" fill={text} style={{ fontSize: 12, fontFamily: "General Sans" }}>
                {s.label.split(" ").slice(0, 2).join(" ")}
              </text>
              {s.label.split(" ").length > 2 && (
                <text x={cx} y={cy + 98} textAnchor="middle" fill={text} style={{ fontSize: 12, fontFamily: "General Sans" }}>
                  {s.label.split(" ").slice(2).join(" ")}
                </text>
              )}
            </g>
          );
        })}
      </svg>
    </div>
  );
};
